// Soft UI Dashboard PRO React components
import SoftBox from "components/SoftComponents/SoftBox";

//Backend access
import PropTypes from "prop-types";

// Images
import TranslinkPlinth from "assets/images/overlays/qld_plinth_thumb.png";
import TranslinkPole from "assets/images/overlays/QLD-eStop_thumb_v2.png";
import TranslinkKerbside from "assets/images/overlays/qld_kerbside.png";
import TranslinkCP from "assets/images/overlays/CMSthumbnailCP.png";
import TfnswNSD from "assets/images/overlays/TfNSW_NSD_thumb.png";
import TranslinkStationlink from "assets/images/overlays/TRANSLINK-UrbanDual-CMS-icon2.png";
import YarraTrams from "assets/images/overlays/YarraTrams_thumb.png";

function setupLiveviewOverlay(overlay_id) {
    if (!overlay_id) {
        return null;
    }

    switch (overlay_id) {
        case 'translink-plinth':
            return TranslinkPlinth;
        case 'translink-bus':
            return TranslinkPole;
        case 'translink-kerbside':
            return TranslinkKerbside;
        case 'translink_connection':
            return TranslinkCP;
        case 'tfnsw_gen2':
            return TfnswNSD;
        case 'translink-stationlink':
            return TranslinkStationlink;
        case 'yarra-trams':
            return YarraTrams;
        case 'no_frame':
        default:
            return null;
    }
}

function setupLiveviewPerspective(url, deviceLayout, overlay_id, isPreview = false) {
    var transformPerspective = 0;

    switch (overlay_id) {
        case 'translink-plinth':
            transformPerspective = isPreview ? "translateX(12%) perspective(250px) rotateY(8deg)" : "translateX(39%) perspective(300px) rotateY(5deg)";

            return (
                <SoftBox
                    component="img"
                    src={url[0]}
                    position="absolute"
                    top="16.7%"
                    height="52.6%"
                    width="auto"
                    sx={{
                        transform: transformPerspective,
                        transformOrigin: "left center",
                        zIndex: 2
                    }}
                />
            );
        case 'translink-bus':
            if (isPreview) {
                return (
                    <SoftBox
                        component="img"
                        src={url[0]}
                        position="absolute"
                        top="19%"
                        height="62.1%"
                        width="auto"
                        sx={{
                            transform: `translateX(11%) rotateX(7deg) perspective(190px) rotateY(10deg) skewY(-2.5deg)`,
                            transformOrigin: "left center",
                            zIndex: 2
                        }}
                    />
                );
            }
            else {
                return (
                    <SoftBox
                        component="img"
                        src={url[0]}
                        position="absolute"
                        top="21.5%"
                        height="56.9%"
                        width="auto"
                        sx={{
                            transform: "translateX(15%) skewY(-1.5deg) perspective(700px) rotateY(17deg) scaleY(1.04)",
                            transformOrigin: "center",
                            zIndex: 2
                        }}
                    />

                )
            }
        case 'translink-kerbside':
            return (
                <SoftBox
                    component="img"
                    src={url[0]}
                    sx={{
                        position: 'absolute',
                        top: '9.2%',
                        left: '38%',
                        width: '56.3%',
                        height: 'auto',
                        transform: deviceLayout != "mobile" ? "rotateX(6deg) perspective(650px) rotateY(9deg) skewY(0.5deg)" : "rotateX(6deg) perspective(500px) rotateY(8deg) skewY(0.5deg)",
                        transformOrigin: "top left",
                    }}
                />
            );
        case 'translink_connection':
            return (
                <SoftBox
                    component="img"
                    src={url[0]}
                    position="absolute"
                    top="19%"
                    height="62.1%"
                    width="auto"
                    sx={{
                        transform: "translateX(9%) rotateX(2deg) perspective(600px) rotateY(13deg) skewY(-1.5deg);",
                        transformOrigin: "left center",
                        zIndex: 2
                    }}
                />
            );
        case 'tfnsw_gen2':
            return (
                <SoftBox
                    component="img"
                    src={url[0]}
                    position="absolute"
                    top="19%"
                    height="62.1%"
                    width="auto"
                    sx={{
                        transform: "translateX(9%) rotateX(2deg) perspective(600px) rotateY(13deg) skewY(-1.5deg);",
                        transformOrigin: "left center",
                        zIndex: 2
                    }}
                />
            );
        case 'translink-stationlink':
            return (
                <SoftBox
                    component="img"
                    src={url[0]}
                    position="absolute"
                    top="19%"
                    height="62.1%"
                    width="auto"
                    sx={{
                        transform: "translateX(9%) rotateX(2deg) perspective(600px) rotateY(13deg) skewY(-1.5deg);",
                        transformOrigin: "left center",
                        zIndex: 2
                    }}
                />
            );
        case 'yarra-trams':
            return (
                <SoftBox
                    component="img"
                    src={url[0]}
                    position="absolute"
                    top="24.3%"
                    height="36.7%"
                    width={isPreview ? "unset" : "76%"}
                    sx={{
                        transform: isPreview ? "translateX(16%) rotateX(1deg) perspective(800px) rotateY(20deg) skewY(0.9deg)" : "translateX(31.5%) rotateX(1deg) perspective(900px) rotateY(20deg) skewY(0.9deg)",
                        transformOrigin: "left center",
                        zIndex: 2
                    }}
                />
            );
        case 'no_frame':
        default:
            return (
                <>
                    <SoftBox
                        component="img"
                        src={url[0]}
                        position="absolute"
                        top="17%"
                        height="51%"
                        width="auto"
                        sx={{
                            transform: "translateX(12%) perspective(9cm) rotateY(7deg)",
                            transformOrigin: "left center",
                            zIndex: 2
                        }}
                    />
                    {url?.[1] && (
                        <SoftBox
                            component="img"
                            src={url[1]}
                            position="absolute"
                            top="57%"
                            height="51%"
                            width="auto"
                            sx={{
                                transform: "translateX(12%) perspective(9cm) rotateY(7deg)",
                                transformOrigin: "left center",
                                zIndex: 2
                            }}
                        />
                    )}
                </>
            );
    }
}

function LiveViewDisplay({ liveviews, device, deviceLayout, isPerspectiveLiveview, isPreview }) {

    if (isPreview) {
        if (isPerspectiveLiveview) {
            return (
                <SoftBox
                    display="flex"
                    justifyContent="center"
                    alignItems="flex-start"
                    sx={{ flexGrow: 1, width: '100%', height: '100%', /* overflow: 'auto',*/ maxHeight: 'inherit' }}
                >
                    <SoftBox sx={{ position: 'relative', display: 'flex', justifyContent: "center", maxWidth: '100%', lineHeight: 0, maxHeight: 'inherit' }}>
                        <SoftBox
                            component="img"
                            src={setupLiveviewOverlay(device.overlay_id)}
                            sx={{
                                display: 'block',
                                maxWidth: '100%',
                                height: 'auto',
                                zIndex: 1,
                                position: 'relative',
                                maxHeight: 'inherit'
                            }}
                        />
                        {setupLiveviewPerspective(liveviews.url, deviceLayout, device.overlay_id, false)}
                    </SoftBox>
                </SoftBox>
            );
        }
        else {
            return (
                <SoftBox
                    display="flex"
                    flexDirection="column"
                    justifyContent="center"
                    alignItems="center"
                    sx={{ flexGrow: 1, width: '100%', height: '100%', overflow: 'auto', maxHeight: 'inherit' }}
                >
                    {liveviews.url.map((url, index) => (
                        <SoftBox
                            key={index}
                            component="img"
                            src={url}
                            sx={{
                                minHeight: '100px',
                                maxWidth: "100%",
                                maxHeight: liveviews.url.length > 1 ? "48%" : "100%",
                                objectFit: "contain",
                                boxShadow: "0 4px 6px rgba(0,0,0,0.1)"
                            }}
                        />
                    ))}
                </SoftBox>
            );
        }
    }
    else {
        if (isPerspectiveLiveview) {
            return (
                <SoftBox
                    display="flex"
                    justifyContent="center"
                    alignItems="flex-start"
                    sx={{ flexGrow: 1, width: '100%', height: '100%', overflow: 'auto' }}
                >
                    <SoftBox sx={{ position: 'relative', display: 'inline-block', maxWidth: '100%', lineHeight: 0, transform: device.overlay_id == 'yarra-trams' && 'scale(115%, 130%) translateY(10%)' }}>
                        <SoftBox
                            component="img"
                            src={setupLiveviewOverlay(device.overlay_id)}
                            sx={{
                                display: 'block',
                                maxWidth: '100%',
                                height: 'auto',
                                zIndex: 1,
                                position: 'relative',
                                maxHeight: 'calc(100svh - 16rem - 16px)',
                                minHeight: '600px'
                            }}
                        />
                        {setupLiveviewPerspective(liveviews.url, deviceLayout, device.overlay_id, false)}
                    </SoftBox>
                </SoftBox>
            );
        }
        else {
            return (
                <SoftBox
                    width="calc(100% - 16px)"
                    height="calc(100% - 16px)"
                    display="flex"
                    flexDirection="column"
                    justifyContent="center"
                    alignItems="center"
                    pt={1}
                    px={1}
                    sx={{ overflow: 'auto', minHeight: '100px', maxHeight: 'calc(100svh - 13rem - 24px)' }}
                >
                    {liveviews.url.map((url, index) => (
                        <SoftBox
                            key={index}
                            component="img"
                            src={url}
                            sx={{
                                minHeight: '100px',
                                maxWidth: "100%",
                                maxHeight: liveviews.url.length > 1 ? "48%" : "100%",
                                objectFit: "contain",
                                boxShadow: "0 4px 6px rgba(0,0,0,0.1)"
                            }}
                        />
                    ))}
                </SoftBox>
            );
        }
    }
}

// Typechecking props for the LiveViewDisplay
LiveViewDisplay.propTypes = {
    device: PropTypes.object,
    liveviews: PropTypes.array,
    deviceLayout: PropTypes.string,
    isPerspectiveLiveview: PropTypes.bool,
    isPreview: PropTypes.bool,
};

export default LiveViewDisplay;